import React from 'react';
import CryptoPriceColumn from './mev_price.js';  // adjust path

const MevPriceWidget = () => {
  return (
    <div style={{
      background: 'transparent',  // or '#000000' for dark if needed
      width: '100%',
      minHeight: '50px',  // Small fixed height instead of 10vh
      display: 'flex',
      alignItems: 'center',     // Center vertically
      justifyContent: 'center', // Or 'flex-start' for left-aligned
      margin: 0,
      padding: '10px 0',
      fontFamily: 'Arial, sans-serif',
    }}>
      <CryptoPriceColumn />
    </div>
  );
};

export default MevPriceWidget;